import DropzoneVideo from './DropzoneVideo'

export default DropzoneVideo
